// import { css } from 'styled-components';

export const font = {
  regular: 'font-family: "Times"; font-weight: normal;',
  medium: 'font-family: "Arial"; font-weight: medium;',
  bold: 'font-family: "Arial"; font-weight: bold;',
  size: size => `font-size: ${size}px;`,
};